import { useCommandTrigger } from "@components/chat/channel/trigger/hooks/useCommandTrigger"
import {
  MentionableSuggestion,
  useMentionTrigger,
} from "@components/chat/channel/trigger/hooks/useMentionTrigger"
import { useMentionedGroups } from "@components/chat/channel/trigger/MentionedGroupsContext"
import { FC, useCallback } from "react"
import { MessageInputContextProvider, useMessageInputContext } from "stream-chat-react"

const ChatChannelTriggerProvider: FC = ({ children }) => {
  const currentValue = useMessageInputContext()
  const { setMentionedGroups } = useMentionedGroups()

  const {
    disableMentions,
    mentionAllAppUsers,
    mentionQueryParams,
    useMentionsTransliteration,
    onSelectUser,
  } = currentValue

  const onSelectMention = useCallback(
    (item: MentionableSuggestion) => {
      if (item.type === "user") {
        // User mention
        onSelectUser(item)
      } else {
        if (item.disabled) return
        // @channel mention
        setMentionedGroups((prev) => [...prev, item])
      }
    },
    [onSelectUser, setMentionedGroups]
  )

  const defaultAutocompleteTriggers: any = {
    "/": useCommandTrigger(),
    "@": useMentionTrigger({
      disableMentions,
      mentionAllAppUsers,
      mentionQueryParams,
      onSelectUser: onSelectMention,
      useMentionsTransliteration,
    }),
  }

  const newValue = {
    ...currentValue,
    autocompleteTriggers: defaultAutocompleteTriggers,
  }

  return (
    <MessageInputContextProvider value={newValue}>{children}</MessageInputContextProvider>
  )
}

export default ChatChannelTriggerProvider
